import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 80px;
  gap: 50px;
`

export const DescriptionWrapper = styled.div`
  text-align: center;
  gap: 16px;
  display: flex;
  flex-direction: column;
`

export const ButtonsWrapper = styled.p`
  display: flex;
  justify-content: center;
  gap: 50px;
`
